<template>
    <div class="existing-communities">
      <v-stepper v-model="step" vertical>
        <v-stepper-step step="1" editable>
          Select one or multiple communities
        </v-stepper-step>
        <v-stepper-content step="1">
          <SelectExisting max="3" v-model="selected" :communities="communities"
                          @input="setVennQuery()">
          </SelectExisting>
        </v-stepper-content>
        <v-stepper-step step="2" editable>
          Venn
        </v-stepper-step>
        <v-stepper-content step="2">
          <VennSelect :key="vennQuery"
                      :options="vennList" v-model="vennSelected"
                      :sets="vennSets"
                      @confirm="step = 3">
          </VennSelect>
        </v-stepper-content>
        <v-stepper-step step="3" editable>
          Refine selection
        </v-stepper-step>
        <v-stepper-content step="3">
          <CommunityRules :edit="refinementForm" @update:query="refinement = $event"
                          @confirm="confirm">
          </CommunityRules>
        </v-stepper-content>
      </v-stepper>
    </div>

</template>

<script>
    import {store} from "../../store/store";
    import { mapState } from 'vuex'
    import VennSelect from "./VennSelect"
    import SelectExisting from "./SelectExisting"
    import CommunityRules from "./CommunityRules"
    import {keyToQuery, keyToQuery_, parens, names} from "../../_utils/communityNames"
    import axios from "axios";

    export default {
        name: "ExistingCommunities",
        components: { VennSelect, SelectExisting, CommunityRules },
        props: ["edit"],
        data: () => ({
            step: 1,
            selected: [],
            maxCommunityAmount: 3,
            vennQuery: "",
            vennSelected: [],
            vennList: [],
            vennSets: [],
            refinement: ""
        }),
        computed: {
            refinementForm () {
                if (this.edit) {
                    return this.edit.refinement
                } else {
                    return null
                }
            },
            ...mapState({communities: "communities"})
        },
        methods: {
            setVennQuery () {
                let vennQuery = _.map(this.selected, s => parens(keyToQuery(s.key))).join(" OR ")
                this.vennQuery = vennQuery
                if (!_.isEqual(names(this.selection(this.edit)), names(this.selected))) {
                    store.dispatch("getCommunityVE", this.vennQuery)
                        .then(ve => {
                            this.vennList = ve.value.selection
                            this.vennSets = ve.value.communities
                            this.vennSelected = []
                            this.step = 2
                        })
                } else {
                    this.vennList = _.cloneDeep(this.edit.selection)
                    this.vennSets = this.edit.communities
                    console.log(JSON.parse(JSON.stringify(this.vennList)))
                    this.vennSelected = _.filter(this.vennList, e => e.checked)
                    this.step = 2
                }
            },
            confirm () {
                let query = _.map(this.vennSelected, e => parens(e.key)).join(" OR ")
                if (this.refinement) {
                    query = query + " AND " + this.refinement
                }
                this.$emit("update:query", query)
                this.$emit("confirm")
            },
            selection (edit) {
                if (edit !== null) {
                    let cs = edit.communities
                    function has(c) {
                        return _.includes(cs, keyToQuery(c.key)) ||
                            _.includes(cs, keyToQuery_(c.key))
                    }
                    return _.filter(this.communities, c => has(c) )
                }
            }
        },
        mounted() {
            this.selected = this.selection(this.edit)
        },
        watch: {
            edit: {
                handler (val) {
                    this.selected = this.selection(this.edit)
                },
                deep: true
            },
            communities: {
                handler (val) {
                    this.selected = this.selection(this.edit)
                },
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>
